import { render, staticRenderFns } from "./ViberCampaignDetails.vue?vue&type=template&id=38568efb&scoped=true&"
import script from "./ViberCampaignDetails.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignDetails.vue?vue&type=style&index=0&id=38568efb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38568efb",
  null
  
)

export default component.exports